export default "__VITE_ASSET__CPYFpP1Q__"